import {routerFieldIdAtom} from "./routerStore";
import {useAtom} from "jotai";
import {useActiveCompanyFields} from "../hooks/activeCompanyFieldsHooks";
import {useMemo} from "react";

export const useActiveField = () => {
    const [activeFieldId] = useAtom(routerFieldIdAtom);
    const fieldsState = useActiveCompanyFields();
    const fields = useMemo(() => (fieldsState.isSuccess ? fieldsState.data.fields : []), [fieldsState]);
    const mapByFieldId = useMemo(() => (fieldsState.isSuccess ? fieldsState.data.mapByFieldId : {}), [fieldsState]);

    if (!activeFieldId || !fields) return undefined;
    return mapByFieldId[activeFieldId];
};
